import React, { Fragment, useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import { connect } from 'react-redux'
import stateMap from "../../../../store/stateMap";
import api from '../../../../api';
import { SetInitiative } from "../../../../store/dispatcher";
import { SetInitiativeAccess } from "../../../../store/dispatcher";
import { useParams } from "react-router-dom";
import { EditInitiativeButton }  from '../../../../component/EditInitiative';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { GetInitiativeStatusName, SetInitiativeStatus } from "component/Initiative";
import "../../../../sass/wp-content.scss";
import "../../../../sass/tab/tab.scss";
import "./style.scss";
import { format, parseISO } from "date-fns";
import ThreeDots from "component/ThreeDots";
import { popinfo } from "component/Fancybox/Fancybox";
import LoginBox from "component/LoginBox/LoginBox";
import fancybox from "component/Fancybox/Fancybox";
import { GetInitiativeStatusLabel } from "component/Initiative";
import { ChecklistMeter } from "component/ChecklistMeter";
import {ComponentBridge__InsideBanner} from "component/Bridge";

const calculateProjectTimeframe = (initiative) => {

    let StartISO = parseISO(initiative.StartDate, 'dd-LLLL-Y')
    ,EndISO = parseISO(initiative.EndDate, 'dd-LLLL-Y')

    if(initiative.StartDate != initiative.EndDate)
    {
        if(format(StartISO, 'y') == format(EndISO, 'y'))
        {
            if(format(StartISO, 'M') == format(EndISO, 'M'))
            {
                return format(StartISO, 'dd') + ' - ' + format(EndISO, 'dd LLLL y');
            }
        }
        
        return format(StartISO, 'dd LLLL y') + ' - ' + format(EndISO, 'dd LLLL y')
    }
    else
    {
        return format(StartISO, 'dd LLLL y');
    }
}

const ComponentDynamicImageCanvas = (props) => {
    const [imageDimension, setImageDimensions] = useState({});

    useEffect(() => {
        const img = new Image();
        img.src = props.url;
        img.onload = () => {
            console.log(img.height);
            setImageDimensions({
                height: img.height,
                width: img.width
            });
        };
    }, [props.url])
    return (
        typeof imageDimension.width !== false 
        ? <div className={`image-box ${imageDimension.height >= imageDimension.width ? 'portrait' : ''} `}>
            <img src={props.url} />
        </div>
        : <div className="image-box">
            <span className="skeleton"></span>
        </div>
    )
}

export default connect( stateMap, { SetInitiative, SetInitiativeAccess} )((props) => {

    let {initiative_slug}           = useParams();
    const location                  = useLocation();
    const navigate                  = useNavigate();
    const[isLoading, setIsLoading]  = useState(true);
    const[loadingAccess, setLoadingAccess] = useState(true);

    const getCurrentPath = () => {
        let lastFragment = location.pathname.split('/').pop();

        if(location.pathname.includes('response-survey')) return 'survey';

        switch(lastFragment)
        {
            case 'member':
            case 'updates':
            case 'discussion':
            case 'rating':
            case 'survey':
                return lastFragment;
            case 'sat':
                return lastFragment;
            default:
                return 'about';
        }
    }

    

    const setInitiativeStatus = (status) => {
        SetInitiativeStatus(props.initiative.initiative.InitiativeID, status, props.auth.token)
            .then((initiative) => {
                props.SetInitiative(initiative)
            })
    }

    const DeleteInitiative = (initiative) => {
        let ask = window.confirm('Are You Sure ? ');

        if(!ask)
        {
            return;
        }

        let deletingMessage = popinfo('loading', 'Deleting Initiative', 'Please Wait');
        api('/Initiative', 'delete', {
            initiative_id : initiative.InitiativeID
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                deletingMessage.close();

                navigate({
                    pathname : '/profile'
                });
            })
            .catch(error => {
                popinfo('error', 'Deleting Initiative', error, {}, deletingMessage);
            })
    }

    useEffect(() => {

        api('/initiative', 'get', {
            slug : initiative_slug
            ,include_total_joined : true
        } )
            .then(response => {
                
                setIsLoading(false);

                if(response.initiative.length)
                {
                    props.SetInitiative(response.initiative[0]);   
                }
                else
                {
                    props.SetInitiative(false);
                }
            })

    }, []);

    useEffect(() => {
        
        if(props.auth.user && props.initiative.initiative)
        {
            api('/Membership', 'get', {
                InitiativeID : props.initiative.initiative.InitiativeID
            }, 'Bearer ' + props.auth.token )
                .then(responseMembership => {

                    props.SetInitiativeAccess(responseMembership.membership);

                    setLoadingAccess(false);

                })
                .catch(() => {setLoadingAccess(false)})
        }
        else
        {
            setLoadingAccess(false);
        }


    },[props.auth.user, props.initiative.initiative]);

    return (
        isLoading ? <span className="skeleton"></span> :
        <Fragment>
            {
                !props.initiative.initiative ? <div id="page-initiative-inside" className="text-center text-xl container">Initiative Not Found</div>
                :   
                <div id="page-initiative-inside" className={"type-" + props.initiative.initiative.InitiativeType}>
                        <div className={`initiative-banner bg-${props.initiative.initiative && props.initiative.initiative.InitiativeType}`}>
                            
                            <div className="container full-h ">
                                {
                                    props.initiative.initiative.PlatformSynced !== 'Bridge' &&
                                    <div className="initiative-progress">
                                        <span className={`progress-point ${props.initiative.initiative.CurrentStatus === 'completed' ? 'active' : ''}`}><span>{GetInitiativeStatusLabel(props.initiative.initiative, 'completed')}</span></span>
                                        <span className={`progress-point ${props.initiative.initiative.CurrentStatus === 'rating' ? 'active' : ''}`}><span>{GetInitiativeStatusLabel(props.initiative.initiative, 'rating')}</span></span>
                                        <span className={`progress-point ${props.initiative.initiative.CurrentStatus === 'work-in-progress' ? 'active' : ''}`}><span>{GetInitiativeStatusLabel(props.initiative.initiative, 'work-in-progress')}</span></span>
                                        <span className={`progress-point ${props.initiative.initiative.CurrentStatus === 'recruitment' ? 'active' : ''}`}><span>{GetInitiativeStatusLabel(props.initiative.initiative, 'recruitment')}</span></span>
                                    </div>
                                }
                                <div className="wrapper relative">
                                    
                                    <div className="initiative-information">
                                        <div className="initiative-image-container">
                                            {
                                            props.initiative.initiative.PosterImage 
                                            ? <ComponentDynamicImageCanvas url={props.initiative.initiative.PosterImage}/>
                                            : <span className="image-box"><img src={`${process.env.PUBLIC_URL}/assets/image/crowdbees-default-${Math.floor(Math.random() * 3) + 1}.jpeg`}/></span>
                                            }
                                        </div>
                                        <div className="initiative-identity">
                                            <span className={`the-type bg-${props.initiative.initiative && props.initiative.initiative.InitiativeType}`}>{props.initiative.initiative ? props.initiative.initiative.InitiativeType : 'Please Wait'}</span>
                                            <h1 className="the-title leading-text">
                                                {props.initiative.initiative.Title}
                                                {
                                                    props.initiative.initiative && props.initiative.access && props.initiative.access.membership && props.initiative.access.membership.MemberType == 'admin' &&
                                                    <ThreeDots inline={true}>
                                                        <EditInitiativeButton sentInitiative={props.initiative.initiative} onSave={(initiative)=>{
                                                            props.SetInitiative(initiative);
                                                        }}>Edit</EditInitiativeButton>
                                                        {
                                                            props.initiative.initiative.InitiatorID == props.auth.user.UserID &&
                                                            <button onClick={ e => {
                                                                e.preventDefault();
        
                                                                DeleteInitiative(props.initiative.initiative);
                                                            }}>Delete</button>
                                                        }
                                                    </ThreeDots>
                                                }
                                            </h1>
                                            <div className="initiative-metas">
                                                <div className="the-meta">
                                                    <span className="label bold">Status</span>
                                                    {
                                                        !props.initiative.initiative ? <span className="skeleton"></span> :
                                                        <span className="value">{GetInitiativeStatusName(props.initiative.initiative)}</span>
                                                    }
                                                </div>
                                                <div className="the-meta">
                                                    <span className="label bold"> 
                                                        {
                                                            props.initiative.initiative.InitiativeType == 'event' ? 'Registrant' : 'Talents Joined'
                                                        }
                                                    </span>
                                                    {
                                                        !props.initiative.initiative ? <span className="skeleton"></span> :
                                                        <span className="value">
                                                            {props.initiative.initiative.TotalJoined} 
                                                        </span>
                                                    }
                                                </div>
                                                <div className="the-meta">
                                                    <span className="label bold">
                                                        {
                                                            props.initiative.initiative.InitiativeType == 'event' ? 'Event Date' : 'Timeframe'
                                                        }
                                                    </span>
                                                    {
                                                        !props.initiative.initiative ? <span className="skeleton"></span> :
                                                        <span className="value leading-relaxed">
                                                            { calculateProjectTimeframe(props.initiative.initiative) }
                                                        </span>

                                                    }
                                                </div>
                                            </div>
                                            {
                                                !loadingAccess &&
                                                <div className="initiative-action mt-4">
                                                    {
                                                        props.initiative.access && props.initiative.access.membership && props.initiative.access.membership.MemberType == 'admin' && props.initiative.initiative.CurrentStatus == 'recruitment' &&
                                                        <>
                                                            <a href="#" className="btn btn-white btn-small btn-sm" onClick={e => {
                                                                e.preventDefault();
                                                                setInitiativeStatus('work-in-progress');
                                                            }}>Close { GetInitiativeStatusLabel(props.initiative.initiative, 'recruitment') }</a>
                                                        </>
                                                        
                                                    }
                                                    {
                                                        props.initiative.access && props.initiative.access.membership && props.initiative.access.membership.MemberType == 'admin' && props.initiative.initiative.CurrentStatus == 'work-in-progress' &&
                                                        <>
                                                            <a href="#" className="btn btn-white btn-small btn-sm" onClick={e => {
                                                                e.preventDefault();
                                                                setInitiativeStatus('rating');
                                                            }}>{props.initiative.initiative.InitiativeType == 'event' ? 'End Event' : 'Conclude Initiative'}</a>
                                                        </>
                                                    }
                                                    {
                                                        props.initiative.access && props.initiative.access.membership && props.initiative.access.membership.MemberType == 'admin' && props.initiative.initiative.CurrentStatus == 'rating' &&
                                                        <>
                                                            <a href="#" className="btn btn-white btn-small btn-sm" onClick={e => {
                                                                e.preventDefault();
                                                                setInitiativeStatus('completed');
                                                            }}>End { GetInitiativeStatusLabel(props.initiative.initiative, 'rating') }</a>
                                                        </>
                                                    }
                                                    {
                                                        props.initiative.access && !props.initiative.access.membership && props.initiative.initiative.CurrentStatus == 'recruitment' && 
                                                        <button className="btn btn-white btn-small btn-sm" to="member" onClick={e => {
                                                            e.preventDefault();

                                                            navigate({
                                                                pathname : 'member'
                                                            });

                                                        }}>{props.initiative.initiative.InitiativeType == 'event' ? 'Join Event' : 'Join Initiative'}</button>
                                                    }
                                                    {
                                                        !props.auth.user &&
                                                        <button 
                                                            className="btn btn-login btn-sm btn-white"
                                                            onClick={() => {
                                                                fancybox(<LoginBox/>);
                                                            }}
                                                        >Login to Crowdbees</button>
                                                    }
                                                    {
                                                        props.auth.user &&
                                                        <>
                                                            &nbsp;
                                                            <Link to="survey" className="btn btn-login btn-small btn-white">Participate in Survey</Link>
                                                        </>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {
                                        !loadingAccess && props.initiative.access && props.initiative.access.membership && props.initiative.access.membership.MemberType == 'admin' &&
                                        <div className="initiative-checkmeter-box">
                                            <ChecklistMeter sent_initiative={props.initiative.initiative} />
                                        </div>
                                    }
                                    
                                </div>
                            </div>

                        </div>
                        {
                            props.initiative.initiative.PlatformSynced === 'Bridge' &&
                            <ComponentBridge__InsideBanner/>
                        }
                        <div className="initiative-menus">
                            <div className=" tabs">
                                <Splide options={{
                                    autoWidth : true
                                    ,pagination : false
                                    ,arrows : false
                                }}>
                                    <SplideSlide>
                                        <div className={'tab ' + (getCurrentPath() == 'about' ? 'active' : '') }>
                                            <Link to="./" className="tab-wrapper">About</Link>
                                        </div>
                                    </SplideSlide>
                                    {
                                        props.initiative.access && (props.initiative.access.membership || props.initiative.initiative.CurrentStatus == 'recruitment') &&
                                        <SplideSlide>
                                            <div className={'tab ' + (getCurrentPath() == 'discussion' ? 'active' : '') }>
                                                <Link to="discussion" className="tab-wrapper">Discussion</Link>
                                            </div>
                                        </SplideSlide>
                                    }
                                    {
                                        props.initiative.access.membership && 
                                        <SplideSlide>
                                            <div className={'tab ' + (getCurrentPath() == 'updates' ? 'active' : '') }>
                                                <Link to="updates" className="tab-wrapper">Updates</Link>
                                            </div>
                                        </SplideSlide>
                                    }
                                    {
                                        props.initiative.access &&
                                        <SplideSlide>
                                            <div className={'tab ' + (getCurrentPath() == 'member' ? 'active' : '') }>
                                                <Link to="member" className="tab-wrapper">Members &amp; Roles</Link>
                                            </div>
                                        </SplideSlide>
                                    }
                                    {
                                        props.initiative.access &&
                                        <SplideSlide>
                                            <div className={'tab ' + (getCurrentPath() == 'survey' ? 'active' : '') }>
                                                <Link to="survey" className="tab-wrapper">Survey</Link>
                                            </div>
                                        </SplideSlide>
                                    }
                                    {
                                        props.initiative.initiative.CurrentStatus == 'rating' && props.initiative.access.membership && 
                                        <SplideSlide>
                                            <div className={'tab ' + (getCurrentPath() == 'rating' ? 'active' : '') }>
                                                <Link to="rating" className="tab-wrapper">Ratings</Link>
                                            </div>
                                        </SplideSlide>
                                    }
                                    {
                                        props.initiative.initiative.CurrentStatus == 'completed' 
                                        && props.initiative.access.membership 
                                        && props.initiative.access.membership.MemberType == 'admin'
                                        &&
                                        <SplideSlide>
                                            <div className={'tab ' + (getCurrentPath() == 'sat' ? 'active' : '') }>
                                                <Link to="sat" className="tab-wrapper">SAT Points</Link>
                                            </div>
                                        </SplideSlide>
                                    }
                                </Splide>
                            </div>
                        </div>

                        <Outlet/>
                        
                </div> 
            }
        </Fragment>
    )
});

export {calculateProjectTimeframe}
